// extracted by mini-css-extract-plugin
export var borderRadius = "_en-4";
export var large = "_en-3";
export var logoContainer = "_en-0";
export var nameLogo = "_en-2";
export var small = "_en-1";